import { ConnectionPositionPair, Overlay, OverlayRef } from '@angular/cdk/overlay';
import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
} from '@angular/core';

import { TemplatePortal } from '@angular/cdk/portal';

@Directive({ selector: '[appOverlay]' })
export class OverlayDirective implements OnInit, OnDestroy {
  private overlay = inject(Overlay);
  private viewContainer = inject(ViewContainerRef);

  @Input() public appOverlay: TemplateRef<object>;
  @Input() public origin: HTMLElement;
  private overlayRef!: OverlayRef;

  public ngOnInit(): void {
    this.createOverlay();
    this.attachOverlay();
  }

  public ngOnDestroy(): void {
    this.detachOverlay();
  }

  private createOverlay(): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();
    const positionStrategy = this.overlay
      .position()
      .flexibleConnectedTo(this.origin)
      .withPositions([new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'top' })])
      .withPush(false);

    this.overlayRef = this.overlay.create({
      maxWidth: this.origin.clientWidth,
      maxHeight: this.origin.clientHeight,
      width: this.origin.clientWidth,
      height: this.origin.clientHeight,
      positionStrategy,
      scrollStrategy,
      panelClass: 'cdk-overlay-table-loading',
    });
  }

  private attachOverlay(): void {
    if (!this.overlayRef.hasAttached()) {
      const contentPortal = new TemplatePortal(this.appOverlay, this.viewContainer);

      this.overlayRef.attach(contentPortal);
    }
  }

  private detachOverlay(): void {
    if (this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
    }
  }
}
